import { render, staticRenderFns } from "./assignment-contribute-drawing-modal.vue?vue&type=template&id=05f643e4&scoped=true"
import script from "./assignment-contribute-drawing-modal.vue?vue&type=script&lang=js"
export * from "./assignment-contribute-drawing-modal.vue?vue&type=script&lang=js"
import style0 from "./assignment-contribute-drawing-modal.vue?vue&type=style&index=0&id=05f643e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f643e4",
  null
  
)

export default component.exports